export function formatHashtag(str) {
  return "#" + str.replace(/[^a-zA-Z0-9]/g, "");
}
const REGION_ABBREVIATIONS = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "ON",
  "PE",
  "QC",
  "SK",
  "NT",
  "NU",
  "YT",
];
export function formatHashtagDisplay(str) {
  let formatted = str
    .replace(/[_-]/g, " ")
    .replace(/([a-z])([0-9])/gi, "$1 $2")
    .replace(/([0-9])([a-z])/gi, "$1 $2")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");

  // 🔥 Step 2 — ONLY uppercase abbreviation if it's at the END of the formatted word
  REGION_ABBREVIATIONS.forEach((code) => {
    const lowerCode = code.toLowerCase();
    if (formatted.toLowerCase().endsWith(lowerCode)) {
      formatted =
        formatted.slice(0, formatted.length - lowerCode.length) + code;
    }
  });

  return `#${formatted}`;
}
